/**
 * Treat a DOM attribute as a boolean instead of a string.
 *
 * If you're using custom attributes in your DOM, you may find yourself wanting
 * to toggle an attribute on and off to trigger CSS selectors. Doing this in
 * React is weird, because react uses `Element.setAttribute` to add your
 * attribute to the DOM instead of using actual HTML. For more information, see
 * https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html#changes-in-detail
 *
 * There are some attributes that React is aware of (like `checked` and `disabled`),
 * where it will treat the attribute like a boolean, but if you want the same behavior
 * on a custom attribute, then you can use this function.
 *
 * @param {any} val Any value, will be evaluated by its truthiness
 */
const boolAttr = (val: any): '' | undefined => (val ? '' : undefined) // eslint-disable-line
// The `any` is ok here because we are just checking for truthiness

export default boolAttr
